// Styles
import 'styles/pages/guides/pipeline.scss';

// Scripts
import '~scripts/main';

// Packages
import Cookies from 'js-cookie';

// Blocks
import cardAnimation from '~scripts/blocks/guides/card-animation';
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';
import initSubscribeForm from '~scripts/blocks/subscribe-form';

// Components
import '~scripts/components/modals';

// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// CARD
//
// Animation
cardAnimation();

//
// FORMS
//
// Demo request
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

// Download PDF
const downloadPdfForm = document.querySelectorAll('.js-download-form');

const redirectUserToThankYouPage = () => {
  const currentUrl = window.location.origin + window.location.pathname.replace(/\/+$/, '');
  Cookies.set('thankYouPageAccess', true);
  window.location.href = `${currentUrl}/thank-you`;
};

downloadPdfForm.forEach((form) => {
  initSubscribeForm(form, redirectUserToThankYouPage);

  const submit = form.querySelector('[type="submit"]');
  submit.addEventListener('click', () => {
    window.downloadGuide();
  });
});
